module.exports = __webpack_public_path__ + "static/media/smartphone-content.8cdbc4bd.svg";